import { render, staticRenderFns } from "./privacy-policy-update.vue?vue&type=template&id=0492d584&"
import script from "./privacy-policy-update.vue?vue&type=script&lang=js&"
export * from "./privacy-policy-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports